// CSS Imports
import 'simplebar/src/simplebar.css';
import './index.css';

// React and ReactDOM Imports
import React from 'react';
import ReactDOM from 'react-dom';

// Provider Imports
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { AuthProvider } from './utils/Authorization/AuthContext';
import { SnackbarUtilsConfigurator } from './utils/Toast/SnackbarProvider';

// App Component Import
import App from './App';

// Service Worker and Web Vitals Imports
import * as serviceWorker from './serviceWorker';
import reportWebVitals from './reportWebVitals';
import { SnackbarProvider } from 'notistack';

// Render the Application
ReactDOM.render(
	<HelmetProvider>
		<BrowserRouter>
			<AuthProvider>
				<SnackbarProvider>
					<SnackbarUtilsConfigurator />
					<App />
				</SnackbarProvider>
			</AuthProvider>
		</BrowserRouter>
	</HelmetProvider>,
	document.getElementById('root')
);

// Service Worker registration is now handled by the notification system
// when user enables push notifications or sends test notification

// Measure performance in your app
// reportWebVitals(console.log);
